import React, { FC, useEffect, useState } from "react";
import { EodReport, EodReportData } from "../../entities/interfaces/reports";
import { Card, Table, TableProps } from "antd";
import ReportService from "../../services/reports.service";
import dayjs from "dayjs";

type Props = {
  from: string;
  to: string;
};

const EodReportReport: FC<Props> = ({ from, to }) => {
  const [report, setReport] = useState<EodReport>({
    report: [],
    summary: { grandTotal: 0, totalCard: 0, totalCash: 0, totalUpi: 0 },
  });

  useEffect(() => {
    if (from && to) {
      getEodReport();
    }
  }, [from, to]);

  const getEodReport = async () => {
    const res = await ReportService.eodReport(from, to);
    if (res.success) {
      setReport(res.data);
    }
  };

  const columns: TableProps<EodReportData>["columns"] = [
    {
      title: "S.No",
      key: "index",
      width: 70,
      render: (_text, _record, index) => index + 1,
    },
    {
      title: "Time",
      key: "date",
      render: (record: EodReportData) => {
        return dayjs(record.date).format("hh:mm:a");
      },
    },
    {
      title: "Invoice Id",
      key: "invoiceId",
      render: (record: EodReportData) => {
        return record.invoiceId || "-";
      },
    },
    {
      title: "Card",
      key: "card",
      render: (record: EodReportData) => {
        return record.card || "-";
      },
    },
    {
      title: "Cash",
      key: "cash",
      render: (record: EodReportData) => {
        return record.cash || "-";
      },
    },
    {
      title: "Upi",
      key: "upi",
      render: (record: EodReportData) => {
        return record.upi;
      },
    },
    {
      title: "Total",
      key: "total",
      render: (record: EodReportData) => {
        return record.totalAmount;
      },
    },
  ];

  return (
    <Card bodyStyle={{ padding: "0.5rem" }}>
      <Table
        scroll={{ y: 500 }}
        dataSource={report.report}
        columns={columns}
        pagination={false}
        size="small"
        summary={() => (
          <Table.Summary fixed>
            <Table.Summary.Row>
              <Table.Summary.Cell index={0}></Table.Summary.Cell>
              <Table.Summary.Cell index={6}></Table.Summary.Cell>
              <Table.Summary.Cell index={1}>
                <strong>Total</strong>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={2}>
                <strong>{report.summary.totalCard}</strong>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={3}>
                <strong>{report.summary.totalCash}</strong>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={4}>
                <strong>{report.summary.totalUpi}</strong>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={5}>
                <strong>{report.summary.grandTotal}</strong>
              </Table.Summary.Cell>
            </Table.Summary.Row>
          </Table.Summary>
        )}
      />
    </Card>
  );
};

export default EodReportReport;
